import { Outlet } from "react-router-dom";
import "./App.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import Navbar from "./Components/Navbar";
import { HelmetProvider } from "react-helmet-async";
import ScrollToTop from "./Components/ScrollToTop";
import LessonFooter from "./Components/LessonFooter";
import ThemeSwitcher from "./Components/ThemeSwitcher";
import './Components/theme.css';

const App = () => {
   
    return (
        <HelmetProvider>
            <div className="app-container">
                <Navbar/>
                <ThemeSwitcher />
                <div className="content">
                    <ScrollToTop />
                    <Outlet />
                </div>
                <LessonFooter />
            </div>
        </HelmetProvider>
    );
};

export default App;